import { CardTransactionDTO } from 'core/api';
import { Result } from 'core/infrastructure';
import { BridgeProxy, CardTransactionMetadata } from 'pos/common';
import { Pinpad } from './Pinpad';

const pinpad: Pinpad = {
	async transact(transactionId: string, amount: number, metadata: CardTransactionMetadata): Promise<Result<CardTransactionDTO>> {

		const { posReference, userReference, transactionType, relatedTransactionXmlDetails, askGratuity } = metadata;
		const result = await BridgeProxy.invoke(
			'REGISTER_USER_ACTIVITY',
			BridgeProxy.Endpoints.CardProcessor.Transaction,
			{
				amount,
				posReference,
				userReference,
				transactionType,
				relatedTransactionXmlDetails,
				transactionId,
				askGratuity
			}
		);
		if (!result.ok)
			return Result.error();

		return Result.ok({
			TransactionId: result.transactionId,
			XmlDetails: result.xmlDetails,
			TransactionType: result.transactionType
		});
	}
};

export default pinpad;